import microApps from '@/config/microApps.config'
import { getServiceCurrentDomainDetail } from '@/api/sso/role'
import { queryPageTypeList } from '@/api/sso/pageTypeInfo'

const permission = {
  state: {
    microApps: [...microApps]
  },
  mutations: {
    SET_MICRO_APPS: (state, apps) => {
      state.microApps = apps
    }
  },
  actions: {
    InitMicroAppsEntry ({ commit }, params) {
      return getServiceCurrentDomainDetail({ ...params, systemCode: undefined }).then(async res => {
        const { serviceCurrentDomainDTOList } = res.data
        const apps = [
          ...microApps,
          ...serviceCurrentDomainDTOList
            .map(({ domain, middlePath, ...other }) => {
              // if (middlePath === 'amazon') {
              //   return {
              //     entry: 'http://172.16.6.205:9001',
              //     name: middlePath,
              //   ...other
              //   }
              // }
              return {
                entry: /^http:\/\//.test(domain) ? domain.replace('http://', window.location.protocol + '//') : domain,
                name: middlePath,
                ...other
              }
            })
        ]
        commit('SET_MICRO_APPS', apps)
        // 获取页面类型
        // let isERP = apps.find(item => item.systemCode === 'ORDER_MANAGER' && item.subTab === 7)
        let pageTypeId
        if (params.systemCode === 'ERP') {
          const { data } = await queryPageTypeList({ paging: false, systemCode: params.systemCode, serviceId: params.serviceId })
          pageTypeId = (data || []).find(item => item.selectFlag === 2)?.id
        }
        return { microApps: apps, pageTypeId }
      })
    }
  }
}

export default permission
